// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.price .title {
  height: 30%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0 !important;
}
.price .title h1 {
  font-size: 40px;
  font-weight: 600;
  position: relative;
  z-index: 1111;
  text-align: center;
}
.price .title h2 {
  text-align: center;
}
.price .title p {
  color: var(--ion-color-medium);
  font-size: 16px;
  margin-top: 10px;
  position: relative;
  z-index: 1111;
}
.price .title p span {
  color: var(--ion-color-medium);
}
.price .inputs {
  width: 75%;
  margin: 0 auto;
  gap: 16px;
  margin-top: 32px;
}
.price ion-list {
  height: 100%;
  padding-top: 16px;
  padding: 32px;
  border-bottom: 1px solid var(--ion-color-light);
}
.price ion-list ion-item {
  margin-bottom: 10px;
}
.price ion-list ion-label {
  font-size: 16px !important;
}
.price ion-list ion-note {
  font-size: 16px !important;
}
.price ion-button {
  font-size: 21px !important;
  font-weight: 600;
  height: 70px !important;
  --border-radius: 8px;
}

.data {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.data .title {
  height: 100%;
  padding: 16px;
}
.data .title h1 {
  font-size: 45px;
}
.data .title p {
  font-size: 25px !important;
  margin-bottom: 16px;
}
.data .title p span {
  font-size: 25px !important;
}

.payment-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  gap: 40px;
}
.payment-loading ion-spinner {
  width: 50px;
  display: flex;
  height: 50px;
}
.payment-loading p {
  font-size: 30px;
  margin-bottom: 16px;
}

ion-thumbnail {
  background: rgba(1, 106, 255, 0.09);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  margin-left: 10px !important;
}
ion-thumbnail h6 {
  font-weight: 700;
  color: var(--ion-color-primary);
}
ion-thumbnail ion-skeleton-text {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

@media (max-width: 767px) {
  .data {
    padding-bottom: env(safe-area-inset-bottom) !important;
  }
  .inputs {
    width: calc(100% - 16px) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/giftcards/amount-board/amount-board.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AACN;AAEI;EACE,kBAAA;AAAN;AAGI;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AADN;AAGM;EACE,8BAAA;AADR;AAME;EACE,UAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAJJ;AAOE;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,+CAAA;AALJ;AAOI;EACE,mBAAA;AALN;AAQI;EACE,0BAAA;AANN;AASI;EACE,0BAAA;AAPN;AAWE;EACE,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AATJ;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAVF;AAYE;EACE,YAAA;EACA,aAAA;AAVJ;AAYI;EACE,eAAA;AAVN;AAaI;EACE,0BAAA;EACA,mBAAA;AAXN;AAaM;EACE,0BAAA;AAXR;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;AAdF;AAgBE;EACE,WAAA;EACA,aAAA;EACA,YAAA;AAdJ;AAiBE;EACE,eAAA;EACA,mBAAA;AAfJ;;AAmBA;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;AAhBF;AAkBE;EACE,gBAAA;EACA,+BAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAjBJ;;AAqBA;EACE;IACE,sDAAA;EAlBF;EAqBA;IACE,mCAAA;EAnBF;AACF","sourcesContent":[".price {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  .title {\n    height: 30%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-bottom: 0 !important;\n\n    h1 {\n      font-size: 40px;\n      font-weight: 600;\n      position: relative;\n      z-index: 1111;\n      text-align: center;\n    }\n\n    h2 {\n      text-align: center;\n    }\n\n    p {\n      color: var(--ion-color-medium);\n      font-size: 16px;\n      margin-top: 10px;\n      position: relative;\n      z-index: 1111;\n\n      span {\n        color: var(--ion-color-medium);\n      }\n    }\n  }\n\n  .inputs {\n    width: 75%;\n    margin: 0 auto;\n    gap: 16px;\n    margin-top: 32px;\n  }\n\n  ion-list {\n    height: 100%;\n    padding-top: 16px;\n    padding: 32px;\n    border-bottom: 1px solid var(--ion-color-light);\n\n    ion-item {\n      margin-bottom: 10px;\n    }\n\n    ion-label {\n      font-size: 16px !important;\n    }\n\n    ion-note {\n      font-size: 16px !important;\n    }\n  }\n\n  ion-button {\n    font-size: 21px !important;\n    font-weight: 600;\n    height: 70px !important;\n    --border-radius: 8px;\n  }\n}\n\n.data {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n\n  .title {\n    height: 100%;\n    padding: 16px;\n\n    h1 {\n      font-size: 45px;\n    }\n\n    p {\n      font-size: 25px !important;\n      margin-bottom: 16px;\n\n      span {\n        font-size: 25px !important;\n      }\n    }\n  }\n}\n\n.payment-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  flex-direction: column;\n  gap: 40px;\n\n  ion-spinner {\n    width: 50px;\n    display: flex;\n    height: 50px;\n  }\n\n  p {\n    font-size: 30px;\n    margin-bottom: 16px;\n  }\n}\n\nion-thumbnail {\n  background: rgb(1 106 255 / 9%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 6px;\n  margin-left: 10px !important;\n\n  h6 {\n    font-weight: 700;\n    color: var(--ion-color-primary);\n  }\n\n  ion-skeleton-text {\n    width: 40px;\n    height: 40px;\n    border-radius: 6px;\n  }\n}\n\n@media (max-width: 767px) {\n  .data {\n    padding-bottom: env(safe-area-inset-bottom) !important;\n  }\n\n  .inputs {\n    width: calc(100% - 16px) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
